export default "__VITE_ASSET__CvQIVm$h__"